// extracted by mini-css-extract-plugin
module.exports = {"container":"Tooltip_container__XTMDy","heading":"Tooltip_heading__1ovXa","closeButton":"Tooltip_closeButton__3nmwq"};